import React from "react";
import { Grid } from "@material-ui/core";
import { InputCheckboxMaster, InputTextMaster } from "App/Component/ui";

export default function FormMediaSosial({
  formData,
  handleChange,
  setFormData,
}) {
  return (
    <>
      <p className='fw-600 mt-2'>MEDIA SOSIAL</p>
      <div className='mt-1'>
        <Grid container spacing={1}>
          <Grid item xs={6} sm={3}>
            <InputTextMaster
              name='whatsapp'
              label='WHATSAPP'
              id='whatsapp'
              placeholder='Nomor WhatsApp'
              value={formData.sc_whatsapp}
              onChange={handleChange("sc_whatsapp")}
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <InputTextMaster
              name='email'
              label='E-MAIL'
              id='email'
              value={formData.sc_email}
              placeholder='Alamat Email'
              onChange={handleChange("sc_email")}
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <InputTextMaster
              name='instagram'
              label='INSTAGRAM'
              id='instagram'
              placeholder='instagram'
              value={formData.sc_instagram}
              onChange={handleChange("sc_instagram")}
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <InputTextMaster
              name='facebook'
              label='FACEBOOK'
              id='facebook'
              placeholder='Alamat Facebook'
              value={formData.sc_facebook}
              onChange={handleChange("sc_facebook")}
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <div className='mt-1 ml-2'>
              <InputCheckboxMaster
                checked={formData.status}
                name='status'
                id='status'
                label='AKTIF'
                onChange={() =>
                  setFormData({ ...formData, status: !formData.status })
                }
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
